import type {ReactElement} from 'react';
import {useState} from 'react';
import {ClickableDiv} from '@Components/clickable-div';
import {ColorFill} from '@Components/color-fill';
import {Option} from '@Components/contextual-menu/components/option';
import {QRColorPicker} from '@Components/qr-code-generator/components/qr-color-picker/qr-color-picker';
import styles from './qr-color-option.module.scss';
import type {QRColorOptionProps} from './qr-color-option.types';

export function QRColorOption({label, selectedColor, onColorChange, isForSubOption = false}: QRColorOptionProps): ReactElement {
  const [isPickerOpen, setIsPickerOpen] = useState(false);

  const renderCurrentColorSwatch = (): ReactElement => {
    return (
      <ClickableDiv
        className={styles.qrColorSwatchButton}
        aria-label={label}
        aria-expanded={isPickerOpen}
        onClick={(): void => {
          setIsPickerOpen(!isPickerOpen);
        }}
      >
        <ColorFill color={selectedColor} isTransparent={selectedColor[3] === 0} isSelected={isPickerOpen} />
      </ClickableDiv>
    );
  };

  const renderPicker = (): ReactElement | null => {
    if (!isPickerOpen) {
      return null;
    }
    return (
      <li className={styles.qrColorPickerRow}>
        <QRColorPicker color={selectedColor} onColorChange={onColorChange} />
      </li>
    );
  };

  return (
    <Option label={label} isForSubOption={isForSubOption} optionControl={renderCurrentColorSwatch()}>
      {renderPicker()}
    </Option>
  );
}
